
import Vue from 'vue'

import CustomTextModal from './CustomTextModal.vue'
import { RButton, RInput } from '@/components'
import { mapActions, mapGetters } from 'vuex'

export default Vue.extend({
  name: 'modifyRootVolume',
  data() {
    return {
      quantity: '1',
    }
  },
  components: {
    CustomTextModal,
    RButton,
    RInput,
  },
  props: {
    uuid: {
      type: String,
    },
    profileId: {
      type: String,
    },
    ownerId: {
      type: String,
    },
    isUserOnTrial: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    totalAdditionalVolumeGBs(): number {
      return this.validVolumeValue ? +this.quantity * 25 : 0
    },
    totalPrice(): number {
      return this.validVolumeValue ? +this.quantity * 5 : 0
    },
    modifyRootVolumeRequest(): RequestInfo | undefined {
      return this.requestInfo(this.uuid)?.modifyRootVolume
    },
    validVolumeValue(): boolean {
      return Number.isInteger(+this.quantity) && +this.quantity > 0
    },
    isModifyRootVolumeRequestPending(): boolean {
      return this.requestInfo(this.uuid)?.modifyRootVolume
        ? this.requestInfo(this.uuid)?.modifyRootVolume.pending
        : false
    },
    ...mapGetters({
      requestInfo: 'workstation/requestInfo',
      hasAnyModifyWorkstationRequests: 'workstation/hasAnyModifyWorkstationRequests',
    }),
  },
  methods: {
    async handleModifyRootVolume(): Promise<void> {
      const workstationUuid = this.uuid
      await this.modifyRootVolume({
        uuid: workstationUuid,
        root_volume_increment_size_gb: this.totalAdditionalVolumeGBs,
      })
      this.$rModal.hide('modifyRootVolume')
    },
    handleCancel(): void {
      this.$rModal.hide('modifyRootVolume')
    },
    ...mapActions({
      modifyRootVolume: 'workstation/modifyRootVolume',
    }),
  },
})
